export default "__VITE_ASSET__47e9bc7c__"